import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export interface TeamMember {
  employee_id: number
  first_name: string
  last_name: string
  email: string
  job_title: string | null
  department: string | null
  current_timesheet_status: string
}

export function useManagerTeam() {
  return useQuery({
    queryKey: ['manager', 'team'],
    queryFn: () => fetchApi<TeamMember[]>('/api/manager/team'),
  })
}
